// Single source of truth for AZ City PAC contribution links.
export const DONATE_URL =
  'https://secure.anedot.com/az-city-pac-d8a4f416-b2d3-4ef3-a706-ce492f73f4dc/donate'

/**
 * Anedot prefills its hosted form when an amount is passed on the query string.
 */
export function buildDonateUrl(amount?: number): string {
  if (!amount || amount <= 0) return DONATE_URL
  return `${DONATE_URL}?amount=${Math.round(amount)}`
}
